/* src/app/timeline-workshop/partials/timeline-workshop-absence/timeline-workshop-absence.component.scss */
/*# sourceMappingURL=timeline-workshop-absence.component.css.map */
